module.exports = __webpack_public_path__ + "img/delete-member.d51a70ea.png";